// DO NOT EDIT -- generated from fs/services/capnhook/capnhook.proto

import { EventOptions } from './options.proto';
import * as protobuf from '../../../google/protobuf';

export namespace Admin {

  export const UpdateEventCountsEndpoint = "/grpc/capnhook.Admin/UpdateEventCounts";
  /** Updates the event counts for a given org or the entire set of orgs for managing Subscription quotas */
  export function UpdateEventCounts(sender: (req: UpdateEventCountsRequest, endpoint: string) => Promise<{}>, req: UpdateEventCountsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateEventCountsEndpoint),
      endpoint: UpdateEventCountsEndpoint
    };
  }

  export const BackfillSubscriptionChangeEndpoint = "/grpc/capnhook.Admin/BackfillSubscriptionChange";
  /**
   * Purges and updates the WebhookSubscriptionChange entities with the actual
   * data from the WebhookSubscription entities in all active orgs.
   */
  export function BackfillSubscriptionChange(sender: (req: BackfillSubscriptionChangeRequest, endpoint: string) => Promise<BackfillSubscriptionChangeResponse>, req: BackfillSubscriptionChangeRequest): { promise: () => Promise<BackfillSubscriptionChangeResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillSubscriptionChangeEndpoint),
      endpoint: BackfillSubscriptionChangeEndpoint
    };
  }
}

export namespace MessageBroker {

  export const HandleEventEndpoint = "/grpc/capnhook.MessageBroker/HandleEvent";
  /**
   * HandleEvent takes an event payload and schedules Pub/Sub tasks that send the webhook to all subscribers to that
   * event. It is recommended that you use the helper function capnhook.FireEvent instead to trigger an event, as it
   * adds helpful features like retrying the RPC and JSON marshaling the event payload.
   */
  export function HandleEvent(sender: (req: HandleEventRequest, endpoint: string) => Promise<{}>, req: HandleEventRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, HandleEventEndpoint),
      endpoint: HandleEventEndpoint
    };
  }

  export const TestEndpointEndpoint = "/grpc/capnhook.MessageBroker/TestEndpoint";
  /**
   * TestEndpoint sends a webhook event, with event type "test.endpoint", to the given destination URL, and uses the
   * given secret to sign the payload.
   */
  export function TestEndpoint(sender: (req: TestEndpointRequest, endpoint: string) => Promise<TestEndpointResponse>, req: TestEndpointRequest): { promise: () => Promise<TestEndpointResponse>, endpoint: string } {
    return {
      promise: () => sender(req, TestEndpointEndpoint),
      endpoint: TestEndpointEndpoint
    };
  }

  export const FailuresBySubscriptionEndpoint = "/grpc/capnhook.MessageBroker/FailuresBySubscription";
  /**
   * FailuresBySubscription returns an aggregate view of the send failures that happened in the recent past for a
   * given subscription. The number of failed messages taken into account for calculation is also limited. The
   * specific values for the past duration and the limit can be found in the service implementation.
   */
  export function FailuresBySubscription(sender: (req: FailuresBySubscriptionRequest, endpoint: string) => Promise<FailuresBySubscriptionResponse>, req: FailuresBySubscriptionRequest): { promise: () => Promise<FailuresBySubscriptionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FailuresBySubscriptionEndpoint),
      endpoint: FailuresBySubscriptionEndpoint
    };
  }

  // unsupported streaming endpoint
  export const MonitorSubscriptionsEndpoint = "/grpc/capnhook.MessageBroker/MonitorSubscriptions";
}

export namespace MessageBrokerPublic {

  export const FetchDeliveryAttemptsEndpoint = "/grpc/capnhook.MessageBrokerPublic/FetchDeliveryAttempts";
  /**
   * FetchDeliveryAttempts returns a list of webhook delivery attempts that were made for the given endpoint. This
   * list includes the details of the outcome of the send attempt, and is also filterable by the outcome.
   */
  export function FetchDeliveryAttempts(sender: (req: FetchDeliveryAttemptsRequest, endpoint: string) => Promise<FetchDeliveryAttemptsResponse>, req: FetchDeliveryAttemptsRequest): { promise: () => Promise<FetchDeliveryAttemptsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FetchDeliveryAttemptsEndpoint),
      endpoint: FetchDeliveryAttemptsEndpoint
    };
  }

  export const FetchWebhookEventEndpoint = "/grpc/capnhook.MessageBrokerPublic/FetchWebhookEvent";
  /** FetchWebhookEvent returns information about a webhook event. */
  export function FetchWebhookEvent(sender: (req: FetchWebhookEventRequest, endpoint: string) => Promise<FetchWebhookEventResponse>, req: FetchWebhookEventRequest): { promise: () => Promise<FetchWebhookEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FetchWebhookEventEndpoint),
      endpoint: FetchWebhookEventEndpoint
    };
  }
}

export namespace Subscriptor {

  export const CreateSubscriptionEndpoint = "/grpc/capnhook.Subscriptor/CreateSubscription";
  /** CreateSubscription creates a new webhook endpoint for the provided org. */
  export function CreateSubscription(sender: (req: CreateSubscriptionRequest, endpoint: string) => Promise<Subscription>, req: CreateSubscriptionRequest): { promise: () => Promise<Subscription>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSubscriptionEndpoint),
      endpoint: CreateSubscriptionEndpoint
    };
  }

  export const UpdateSubscriptionEndpoint = "/grpc/capnhook.Subscriptor/UpdateSubscription";
  /** UpdateSubscription modifies an existing subscription. */
  export function UpdateSubscription(sender: (req: UpdateSubscriptionRequest, endpoint: string) => Promise<Subscription>, req: UpdateSubscriptionRequest): { promise: () => Promise<Subscription>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSubscriptionEndpoint),
      endpoint: UpdateSubscriptionEndpoint
    };
  }

  export const DeleteSubscriptionEndpoint = "/grpc/capnhook.Subscriptor/DeleteSubscription";
  /** DeleteSubscription deletes an existing subscription. */
  export function DeleteSubscription(sender: (req: DeleteSubscriptionRequest, endpoint: string) => Promise<Subscription>, req: DeleteSubscriptionRequest): { promise: () => Promise<Subscription>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSubscriptionEndpoint),
      endpoint: DeleteSubscriptionEndpoint
    };
  }

  export const GetSubscriptionEndpoint = "/grpc/capnhook.Subscriptor/GetSubscription";
  /** GetSubscription gets a single subscription */
  export function GetSubscription(sender: (req: GetSubscriptionRequest, endpoint: string) => Promise<Subscription>, req: GetSubscriptionRequest): { promise: () => Promise<Subscription>, endpoint: string } {
    return {
      promise: () => sender(req, GetSubscriptionEndpoint),
      endpoint: GetSubscriptionEndpoint
    };
  }

  export const ListSubscriptionsEndpoint = "/grpc/capnhook.Subscriptor/ListSubscriptions";
  /**
   * TODO(sanjay): Include a field that tells you if the subscription has any send error. Or maybe this data should be
   * returned from a totally new method?
   * ListSubscriptions fetches all the subscriptions for an org.
   */
  export function ListSubscriptions(sender: (req: ListSubscriptionsRequest, endpoint: string) => Promise<ListSubscriptionsResponse>, req: ListSubscriptionsRequest): { promise: () => Promise<ListSubscriptionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSubscriptionsEndpoint),
      endpoint: ListSubscriptionsEndpoint
    };
  }

  export const GetSubscriptionsEndpoint = "/grpc/capnhook.Subscriptor/GetSubscriptions";
  /** GetSubscriptions is used to retrieve all of the active subscriptions for a specific event. */
  export function GetSubscriptions(sender: (req: GetSubscriptionsRequest, endpoint: string) => Promise<GetSubscriptionsResponse>, req: GetSubscriptionsRequest): { promise: () => Promise<GetSubscriptionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSubscriptionsEndpoint),
      endpoint: GetSubscriptionsEndpoint
    };
  }

  export const ListAvailableEventsEndpoint = "/grpc/capnhook.Subscriptor/ListAvailableEvents";
  /**
   * ListAvailableEvents is used to retrieve all of the available events an org can subscribe to. When an empty list
   * of events is returned, clients should consider webhooks diabled for the given org.
   */
  export function ListAvailableEvents(sender: (req: ListAvailableEventsRequest, endpoint: string) => Promise<ListAvailableEventsResponse>, req: ListAvailableEventsRequest): { promise: () => Promise<ListAvailableEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListAvailableEventsEndpoint),
      endpoint: ListAvailableEventsEndpoint
    };
  }
}

/** FailedSendReason represents the various failures that occur when capnhook sends an outbound webhook to its destination. */
export enum FailedSendReason {
  /** zero value; do not use */
  INVALID = 0,
  /** @deprecated */
  INTERNAL_ERROR = 1,
  NETWORK_ERROR = 2,
  BAD_HTTP_STATUS_CODE = 3,
  THROTTLED = 4,
  IP_NOT_PUBLIC = 5
}

export interface UpdateEventCountsRequest {
  /**
   * NB: The org_id specifies the org whose per-event subscription counts are being updated.
   * If not specified, the all_orgs flag should be set to true and all per-event subscription counts will be updated.
   */
  orgId: string;
  allOrgs: boolean;
}

export interface HandleEventRequest {
  orgId: string;
  /** The string name of the event payload. See capnhook.GetEventName. */
  event: string;
  /**
   * The data payload for this webhook event. The payload MUST be a valid
   * JSON-encoded object. NOTE: this uses bytes instead of google.protobuf.Struct
   * for efficiency (to reduce marshaling/unmarshaling costs). Clients do not
   * directly use this request type: client APIs are more strongly-typed and
   * handle the JSON encoding.
   */
  payload: protobuf.bytes;
  /** Optional idempotence key */
  idempotenceKey: string;
}

export interface HandleEventError {
  reason: HandleEventError.Reason;
}

export namespace HandleEventError {
  export enum Reason {
    UNKNOWN = 0,
    MESSAGE_TOO_LARGE = 1,
    BAD_MESSAGE = 2
  }
}

export interface Subscription {
  /** @deprecated */
  orgId: string;
  /** The unix time for when the subscription was created */
  created: protobuf.timestamp | null;
  /** The unix time for when the subscription was last updated */
  modified: protobuf.timestamp | null;
  /** Whether or not this endpoint is enabled. */
  enabled: boolean;
  /** The destination of the webhook */
  url: string;
  /**
   * A list of the events that should be sent to the corresponding url.
   * A "*" means all events will be pushed to this subscription. For event
   * types that have sub-events, the actual string value present in this
   * slice should be in the form "{event}:{subevent}".
   */
  events: string[];
  /** These rate limiter setting are used for throttling outgoing calls to webhook subscriptions */
  ratePerSec: number;
  burstSize: number;
  /** Set by us when we disable the subscription due to repeated failures */
  wasAutoDisabled: boolean;
}

export interface CreateSubscriptionRequest {
  orgId: string;
  /** The URL that the payload will be posted to */
  url: string;
  /** The secret used to sign the payload. */
  secret: string;
  /**
   * List of events that are being subscribed to. For event types that have
   * sub-events, the actual string value present in this slice should be in
   * the form "{event}:{subevent}", to also indicate the sub-event that this
   * subscription handles. If this subscription is to handle multiple such
   * sub-events, then there should be multiple such values (all with the same
   * "{event}:" prefix).
   */
  events: string[];
  /** Rate limiter settings */
  ratePerSec: number;
  burstSize: number;
}

export interface UpdateSubscriptionRequest {
  orgId: string;
  /** The destination URL of the subscription that has to be modified. */
  url: string;
  /** The new destination URL if different from the existing URL. */
  newUrl: string | null;
  /** If true, webhooks will be sent to the subscriptions URL */
  enabled: boolean | null;
  /** The new secret to use. */
  secret: string | null;
  /**
   * The new list of events. If empty, the event list will not be changed. For
   * event types that have sub-events, the actual string value present in this
   * slice should be in the form "{event}:{subevent}", to also indicate the
   * sub-event that this subscription handles. If this subscription is to handle
   * multiple such sub-events, then there should be multiple such values (all
   * with the same "{event}:" prefix).
   */
  events: string[];
  /** Rate limiter settings */
  ratePerSec: number;
  burstSize: number;
}

export interface DeleteSubscriptionRequest {
  orgId: string;
  /** The destination URL of the subscription */
  url: string;
}

export interface GetSubscriptionRequest {
  orgId: string;
  /** The destination URL of the subscription */
  url: string;
}

export interface ListSubscriptionsRequest {
  orgId: string;
}

export interface ListSubscriptionsResponse {
  subscriptions: Subscription[];
}

export interface GetSubscriptionsRequest {
  orgId: string;
  /**
   * The event name used to filter the subscriptions. For events that have
   * sub-events, this should be a full event name (including sub-event) in
   * the form "{event}:{subevent}".
   */
  eventName: string;
}

export interface GetSubscriptionsResponse {
  subscriptions: Subscription[];
}

export interface ListAvailableEventsRequest {
  orgId: string;
}

export interface ListAvailableEventsResponse {
  events: EventMetadata[];
}

export interface EventMetadata {
  /**
   * The name of the event. This is an internal name, not a display name.
   * The convention is all lower-case, with words separated by dots.
   */
  name: string;
  /** Options for this event. This includes things like display name. */
  options: EventOptions | null;
  /** The list of supported versions for this event type. */
  versions: number[];
}

export interface FailuresBySubscriptionRequest {
  orgId: string;
  /** The destination URL of the subscription */
  url: string;
}

/**
 * Every distinct error, that occurred during the delivery of a webhook message, contains corresponding information that
 * could help customers debug the problem.
 */
export interface FailuresBySubscriptionResponse {
  /** Distinct errors sorted in ascending order of the first time the error happened. */
  errors: FailuresBySubscriptionResponse.Error[];
  /**
   * The duration over which the failed messages are taken for aggregation. All messages that were added to the
   * dead-letter-queue between time.Now().Add(-recent_past) and time.Now() will be used.
   */
  duration: protobuf.duration | null;
  /**
   * The number of messages pulled from the dead-letter-queue and used for aggregation. Note that the service
   * implementation limits the number of messages pulled in order to prevent from making unbounded queries. So, not
   * all of the messages in the specified time range may be used for aggregation.
   * TODO(sanjay): The above field will be the value defined by the bigtable fetch limit at the most. We might
   * want a way to show our users that there might have been more events that weren't included in our calculation.
   */
  numMessages: number;
}

/**
 * Every distinct error, that occurred during the delivery of a webhook message, contains corresponding information that
 * could help customers debug the problem.
 */
export namespace FailuresBySubscriptionResponse {
  export interface Error {
    cardinality: number;
    /** The first time this error occurred.... */
    first: protobuf.timestamp | null;
    /** The last time this error occurred. */
    last: protobuf.timestamp | null;
    reason: FailedSendReason;
    /** Populated only when reason is BAD_HTTP_STATUS_CODE. */
    httpStatusCode: number;
  }
}

export interface TestEndpointRequest {
  orgId: string;
  /** The destination URL of the endpoint that needs to be tested. It is left empty if the endpoint doesn't exist. */
  url: string;
  /** Optional destination URL which has to be tested against. If empty, capnhook will use the url field. */
  newUrl: string;
  /**
   * Optional secret to sign the test event payload with. If empty, capnhook will use the secret on the endpoint
   * specified by the url field.
   */
  secret: string;
  /** Email of the user initiating the test event. */
  initiatorEmail: string;
}

export interface TestEndpointResponse {
  /** The HTTP status code after completing a network call. An empty status code means that the send was a failure. */
  httpStatusCode: number;
  /**
   * Populated when the send resulted in a failure. It includes the cases where the HTTP status code of the response
   * was considered a failure by capnhook, i.e. non-2XX status codes.
   */
  reason: FailedSendReason;
}

export enum TaskDeathReason {
  UNKNOWN = 0,
  /** When the accompanying send attempt resulted in a non-retryable failure. */
  FATAL_SEND_FAILURE = 1,
  /** When the task reaches its max lifetime. */
  REACHED_MAX_TASK_LIFETIME = 2,
  /** When the corresponding event was disabled by the feature flag. */
  EVENT_NAME_DISABLED = 3,
  /** When the corresponding event was removed from the endpoint configuration. */
  EVENT_NAME_REMOVED = 4,
  /** When the endpoint was disabled. */
  ENDPOINT_DISABLED = 5,
  /** When the endpoint was deleted. */
  ENDPOINT_DELETED = 6,
  /** When the event for a particular org is cancelled by the feature flag. */
  EVENT_NAME_CANCELLED = 7
}

export interface DeliveryAttempt {
  eventId: string;
  attempted: protobuf.timestamp | null;
  /** Version of the event name that was sent. */
  version: number;
  success?: DeliveryAttempt.Success | null;
  failureRetry?: DeliveryAttempt.FailureRetry | null;
  failureFinal?: DeliveryAttempt.FailureFinal | null;
}

export namespace DeliveryAttempt {
  export interface Success {
    httpStatusCode: number;
  }

  export interface FailureRetry {
    reason: FailedSendReason;
    httpStatusCode: number;
  }

  export interface FailureFinal {
    reason: FailedSendReason;
    httpStatusCode: number;
    deathReason: TaskDeathReason;
  }

  export enum attempt {
    success = 4,
    failureRetry = 5,
    failureFinal = 6
  }

  export function attempt_oneof(m: DeliveryAttempt): { opt: attempt.failureFinal, val: DeliveryAttempt.FailureFinal } | { opt: attempt.failureRetry, val: DeliveryAttempt.FailureRetry } | { opt: attempt.success, val: DeliveryAttempt.Success } | null {
    if (m.success != null) { return { opt: attempt.success, val: m.success } }
    if (m.failureRetry != null) { return { opt: attempt.failureRetry, val: m.failureRetry } }
    if (m.failureFinal != null) { return { opt: attempt.failureFinal, val: m.failureFinal } }
    return null;
  }
}

export interface FetchDeliveryAttemptsRequest {
  orgId: string;
  /** URL of the endpoint for which the list of delivery attempts need to be fetched. */
  url: string;
  /** An optional parameter that represents the cursor to start listing the delivery attempts from. */
  paginationToken: string;
  /**
   * An Optional parameter that indicates number of attempts to fetch. If the limit is empty or greater than the
   * maximum limit (100), then this value is defaulted to 10.
   */
  limit: number;
  /** List of kinds of attempt outcomes to filter on. If this list is empty, then all kinds of outcomes are returned. */
  filters: FetchDeliveryAttemptsRequest.AttemptOutcome[];
}

export namespace FetchDeliveryAttemptsRequest {
  export enum AttemptOutcome {
    INVALID_ATTEMPT_OUTCOME = 0,
    SUCCESS = 1,
    FAILURE_RETRY = 2,
    FAILURE_FINAL = 3
  }
}

export interface FetchDeliveryAttemptsResponse {
  /** List of delivery attempts. */
  attempts: DeliveryAttempt[];
  /** The token for fetching the next set of results. If this token is empty, then there are no more results. */
  nextPaginationToken: string;
}

export interface FetchWebhookEventRequest {
  eventId: string;
  /** The version of the payload to return. */
  version: number;
}

export interface FetchWebhookEventResponse {
  payload: protobuf.bytes;
  eventDisplayName: string;
}

export interface SubscriptionChange {
  orgId: string;
  /** The kind of webhook event that FullStory system supports. */
  eventName: string;
  /**
   * Describes the type of change; whether the org has a new subscription to
   * this event name, or the org has removed all subscriptions to the event
   * name.
   */
  type: SubscriptionChangeType;
  /** If set, represents an FNV hash of the current state, for sanity checking. */
  fnvHash: protobuf.bytes;
}

export enum SubscriptionChangeType {
  SUBSCRIPTION_CHANGE_TYPE_UNSET = 0,
  /** A new subscription was created for an event by an org. */
  SUBSCRIPTION_CHANGE_TYPE_CREATE = 1,
  /** An existing subscription for an event was deleted by an org. */
  SUBSCRIPTION_CHANGE_TYPE_DELETE = 2
}

export interface BackfillSubscriptionChangeRequest {
  mode: BackfillSubscriptionChangeRequest.BackfillMode;
  /**
   * The number of concurrent workers to use to fetch subscription info from
   * datastore across all namespaces. This is optional, and will default to 2.
   */
  numWorkers: number;
}

export namespace BackfillSubscriptionChangeRequest {
  export enum BackfillMode {
    BACKFILL_MODE_VERIFY = 0,
    BACKFILL_MODE_UPDATE = 1
  }
}

export interface BackfillSubscriptionChangeResponse {
  /** Map of orgIds to the count of configured subscriptions if they are > 0. */
  subCounts: { [key: string]: number };
  /**
   * Map of orgIds to the sub counts on the WebbhookSubscriptionChange entity,
   * for which the counts do match the number of actual subscriptions. This is
   * meaningful only in VERIFY mode.
   */
  desyncedCounts: { [key: string]: number };
}
